module.exports = __webpack_public_path__ + "static/media/house5.3f2c99bf.png";